export default __webpack_public_path__ + "static/media/walk.9bbdac66.svg";